import type { PropsWithChildren } from 'react';
import type React from 'react';

import { useLocation } from 'react-router';

import { Redirect } from '@change-corgi/core/react/router';

import { useStartAPetitionPageData } from '../../pageData';

import { StepStateContextProvider } from './context';
import { useStepState } from './hooks/useStepState';

export const StepStateProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const stepState = useStepState();
	const location = useLocation();
	const {
		data: { experiments },
	} = useStartAPetitionPageData();

	const isS2SFlow = Boolean(stepState.data.metadata.flowKey === 'supporter-to-starter');
	if (!experiments.starfishSapVersion3.variation.includes('control') && !isS2SFlow)
		return <Redirect to={`/start-a-petition/intro${location.search}`} />;

	return <StepStateContextProvider {...stepState}>{children}</StepStateContextProvider>;
};
